/* eslint-disable consistent-return */
/* eslint-disable camelcase */

import { updateTheme } from '@lib/axios/theme'
import { useMutation, useQueryClient } from 'react-query'
import useSuccess from '@hooks/useSuccess'
import useCloseDialog from '@hooks/useCloseDialog'

const useUpdate = () => {
  const showSuccess = useSuccess('Sukses', 'Sukses Mengubah Tema')
  const closeDialog = useCloseDialog()
  const queryClient = useQueryClient()
  const mutation = useMutation(
    (data) => updateTheme(data)
  )

  return (data) => mutation.mutate(data, {
    onError: () => closeDialog(),
    onSuccess: () => {
      showSuccess()
      queryClient.invalidateQueries('saas-theme')
    },
  })
}

export default useUpdate
